import Vue from "vue";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import router from "@/router";
import { SMUser } from "@/store";

const HISTORY_ROUTE_DEPTH_LEVEL = 2;

const REFRESH_INTERVAL = 5 * 60 * 1000;

const LOGOUT_INTERVAL = 5 * 60 * 1000;

const CASES = "cases";

@Module({ name: "MApp", namespaced: true })
export default class MApp extends VuexModule {
  routerHistory: string[] = [];

  // QUESTION: DEV-8257. Why we use (HISTORY_ROUTE_DEPTH_LEVEL: -2) number?
  get previousRouterHistoryPath() {
    if (this.routerHistory.length < HISTORY_ROUTE_DEPTH_LEVEL) return null;

    return this.routerHistory[this.routerHistory.length - HISTORY_ROUTE_DEPTH_LEVEL];
  }

  @Mutation
  addRouteToRouterHistory(path: string) {
    this.routerHistory.push(path);
  }

  previousPath = "";

  @Mutation
  setPreviousPath(path: string) {
    this.previousPath = path;
  }

  @Mutation
  unsetPreviousPath() {
    this.previousPath = "";
  }

  previousUserId = 0;

  @Mutation
  setPreviousUserId(id: number) {
    this.previousUserId = id;
  }

  @Mutation
  unsetPreviousUserId() {
    this.previousUserId = 0;
  }

  pageTitle = "";

  get currentPageTitle() {
    return this.pageTitle;
  }

  @Mutation
  setPageTitle(payload: string) {
    if (!payload) return;

    this.pageTitle = payload;

    this.pageTitleLink = "";

    this.pageSection = "";
  }

  pageTitleLink = "";

  get currentPageTitleLink() {
    return this.pageTitleLink;
  }

  @Mutation
  setPageTitleLink(payload: string) {
    if (payload) this.pageTitleLink = payload;
  }

  pageSection = "";

  get currentPageSection() {
    return this.pageSection;
  }

  @Mutation
  setPageSection(payload: string) {
    if (payload) this.pageSection = payload;
  }

  pageSubTitle = "";

  get currentPageSubTitle() {
    return this.pageSubTitle;
  }

  @Mutation
  setPageSubTitle(payload: string) {
    this.pageSubTitle = payload ?? "";
  }

  pageDescription = "";

  get currentPageDescription() {
    return this.pageDescription;
  }

  @Mutation
  setPageDescription(payload: string) {
    this.pageDescription = payload ?? "";
  }

  noteActive = false;

  @Mutation
  toggleNoteActive() {
    this.noteActive = !this.noteActive;
  }

  @Mutation
  hideNotes() {
    this.noteActive = false;
  }

  authOnServer = false;

  @Mutation
  checkAuthOnServer() {
    this.authOnServer = true;
  }

  @Mutation
  resetAuthOnServer() {
    this.authOnServer = false;
  }

  refreshDate = null;

  @Mutation
  updateRefreshDate() {
    this.refreshDate = new Date();
  }

  refreshInterval = null;

  init = false;

  @Mutation
  clearRefresh() {
    this.refreshInterval = null;
  }

  @Mutation
  refresh(isMaintenanceMode = false) {
    const token = window.localStorage.getItem("auth_token_default");

    if (!token || this.init || isMaintenanceMode) return;

    this.init = true;

    this.refreshInterval = setInterval(async () => {
      const token = window.localStorage.getItem("auth_token_default");

      if (!token) return;

      if (SMUser.isExpert) return await Vue.auth?.refresh();

      const newDate = new Date();

      if (newDate.getTime() - this.refreshDate.getTime() >= LOGOUT_INTERVAL) return;

      await Vue.auth?.refresh();
    }, REFRESH_INTERVAL);
  }

  companyId = 0;

  @Mutation
  setCompanyId(payload: number) {
    this.companyId = payload;
  }

  companyName = "";

  @Mutation
  setCompanyName(payload: string) {
    this.companyName = payload;
  }

  employeeName = "";

  @Mutation
  setEmployeeName(payload: string) {
    if (this.employeeName === payload) return;

    this.employeeName = payload;
  }

  employeeWorkingStatus = "";

  @Mutation
  setEmployeeWorkingStatus(payload: string) {
    this.employeeWorkingStatus = payload;
  }

  needsUpdate = false;

  @Mutation
  setNeedsUpdate(value: boolean) {
    this.needsUpdate = value;
  }

  hasSlCandidatesTab = false;

  @Mutation
  setHasSlCandidatesTab(value: boolean) {
    this.hasSlCandidatesTab = value;
  }

  get backLink(): string | undefined {
    return router.currentRoute?.meta?.backLink || this.bl;
  }

  bl = "";

  @Mutation
  setBackLink(value: string) {
    this.bl = value;
  }

  @Action
  goBack() {
    if (!this.backLink) return;

    if (this.routerHistory.length === 1 && this.routerHistory[0].includes(CASES)) {
      const id = Number(localStorage.getItem("case_id"));

      const path = `/${CASES}/${id}/dashboard/0`;

      router.push(path);

      return;
    }

    let previousPath = this.previousRouterHistoryPath;

    if (!previousPath) previousPath = `${SMUser.basePath}${this.backLink}`;

    if (previousPath.includes("//")) previousPath = previousPath.replace("//", "/");

    router.push(previousPath);

    this.context.commit("setBackLink", "");
  }
}
